import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { ControlFieldComponent } from '../control-field/control-field.component';
import { PrimeNgControlComponent } from '../prime-ng-control/prime-ng-control.component';

@Component({
  selector: 'ui-number-field',
  standalone: true,
  imports: [InputNumberModule, ControlFieldComponent, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberFieldComponent),
      multi: true,
    },
  ],
  templateUrl: './number-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberFieldComponent extends PrimeNgControlComponent<
  number | null
> {
  public readonly suffix = input('');
}
